import React, { memo } from "react";
import Text from "../../../../../../shared-components/css-modules/lexus/atoms/Text";
import styles from "./Overview.module.scss";
import { useCarConfigSelector } from "../../../../../redux/store";
import Price from "../../price/Price";
import { showAccessoriesRate } from "../../../../../utils/financeInsuranceRate";
import Icon from "../../../../../../shared-components/css-modules/lexus/atoms/Icon";
import { CarConfigLabel } from "../../../../../utils/labelUtils";
import { useCarConfigCCISNormalization, useCarIds } from "../../../../../hooks/useAphCCISNormalization";
import { getColorBackgroundVisual, getColorVisual } from "../../../../../utils/visualUtils";
import { useComponentRegistry } from "../../../componentRegistry";
import { CarConfigConfigureSection } from "../../../../../utils/types/SectionTypes";
import { CarConfigConfigureSectionsLbx } from "../../../../../utils/types/SectionTypesLbx";

const OverviewColour = (): JSX.Element => {
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const carConfigSettings = useCarConfigSelector((state) => state.carConfigSettings);
    const useLbxJourney = useCarConfigSelector((state) => state.commonSettings.query.useLbxJourney || false);

    const colour = useCarConfigSelector((state) => state.basket.colour);

    const carIds = useCarIds();
    const carImageInput = useCarConfigCCISNormalization();
    const imageColor = getColorVisual(colour, commonSettings, carIds, carImageInput);
    const bgColor = getColorBackgroundVisual(colour, commonSettings, carIds);
    const OverviewItemWrapper = useComponentRegistry("OverviewItemWrapper");

    return (
        <OverviewItemWrapper
            title="carConfigOverviewTileColour"
            editSection={
                useLbxJourney ? CarConfigConfigureSectionsLbx.AtmosphereColor : CarConfigConfigureSection.Colour
            }
            image={imageColor}
            bg={bgColor}
        >
            <ul role="list" className={styles.sublist}>
                <li className={styles.listitem}>
                    <div>
                        <Text variant="apheleia-body-small" spacing="spacing-0">
                            {colour.name}
                        </Text>
                        <Text variant="apheleia-body-small" spacing="spacing-0">
                            {colour.type}
                        </Text>
                    </div>
                    <div className={styles.listprice}>
                        <Text variant="apheleia-body" spacing="spacing-0">
                            {colour.standard || colour.price.cash === 0 ? (
                                <span className={styles.included}>
                                    <CarConfigLabel label="carConfigIncluded" />
                                    <span className={styles["included-icon"]}>
                                        <Icon variant="check" sizing="sm" aria-hidden="true" />
                                    </span>
                                </span>
                            ) : (
                                <>
                                    +&nbsp;
                                    <Price
                                        price={colour.price}
                                        forceCashPrice={!showAccessoriesRate(commonSettings, carConfigSettings)}
                                    />
                                </>
                            )}
                        </Text>
                    </div>
                </li>
            </ul>
        </OverviewItemWrapper>
    );
};

export default memo(OverviewColour);
